// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpansionPanel_container__3VCV0","expansionHeader":"ExpansionPanel_expansionHeader__F5TpR","expansionContent":"ExpansionPanel_expansionContent__2DXZ_"};